module.exports = __webpack_public_path__ + "img/tank.94f27dee.png";